import { render, staticRenderFns } from "./WorkReviewModal.vue?vue&type=template&id=0f6a0920&scoped=true"
import script from "./WorkReviewModal.vue?vue&type=script&lang=js"
export * from "./WorkReviewModal.vue?vue&type=script&lang=js"
import style0 from "./WorkReviewModal.vue?vue&type=style&index=0&id=0f6a0920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a0920",
  null
  
)

export default component.exports